import {windNameMap, wind_directions} from './options'
// 绘制污染玫瑰图风向角表盘
export function drawWindDial({ ctx, n, center, c = '#ccc', w = 1 }) {
  const { x, y, r } = center;
  var angle = (Math.PI * 2) / n;
  var currentAngle = 0;
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
  ctx.arc(x, y, 2 * r, 0, Math.PI * 2);
  ctx.arc(x, y, 3 * r, 0, Math.PI * 2);
  for (var i = 1; i <= n; i++) {
    var name = windNameMap[i];
    // 移动至起始点
    ctx.moveTo(x, y);
    // 绘制最外围
    ctx.lineTo(
      x + 3 * r * Math.sin(currentAngle),
      y + 3 * r * Math.cos(currentAngle)
    );
    // 绘制名称
    ctx.save();
    var text_x = ctx.measureText(name).width / 2;
    ctx.translate(x, y);
    ctx.rotate(currentAngle);
    ctx.fillStyle = '#000';
    ctx.font = 'bold 12px sans-serif';
    ctx.fillText(name, -text_x, -3 * r - 5);
    ctx.restore();
    currentAngle = currentAngle + angle;
  }
  ctx.strokeStyle = c;
  ctx.lineWidth = w;
  ctx.stroke();
  ctx.closePath();
}

// 计算像素半径
export const calculateMapPixelRadius = ({ lng, lat, map, distance }) => {
  // 中心点坐标
  var point = new BMap.Point(lng, lat);
  var center = map.pointToPixel(point);
  // 半径
  var turfPoint = turf.point([lng, lat]);
  var bearing = 90;
  var options = { units: 'kilometers' };
  var destinationPoint = turf.destination(
    turfPoint,
    distance,
    bearing,
    options
  );
  var coordinates = destinationPoint.geometry.coordinates;
  var destination = new BMap.Point(coordinates[0], coordinates[1]);
  var dCenter = map.pointToPixel(destination);
  var radius = Math.abs(center.x - dCenter.x);
  return { x: center.x, y: center.y, r: radius };
};

// 边界坐标转换(wgs84转bd09)
export function transformCoordinatesPolygon(data) {
  // 边界坐标
  if (data && data.length) {
    for (var i = 0; i < data.length; i++) {
      var poly_gcj = coordtransform.wgs84togcj02(
        data[i][0],
        data[i][1]
      );
      var poly_bd = coordtransform.gcj02tobd09(poly_gcj[0], poly_gcj[1]);
      data[i][0] = poly_bd[0];
      data[i][1] = poly_bd[1];
    }
  }
  return data;
}

// 风点的坐标转换(wgs84转bd09)
export function transformCoordinatesPoints(data) {
  // 风场坐标
  if (data && data.length) {
    for (let d of data) {
      if (d.lng && d.lat) {
        var wind_gcj = coordtransform.wgs84togcj02(d.lng, d.lat);
        var wind_bd = coordtransform.gcj02tobd09(wind_gcj[0], wind_gcj[1]);
        d.lng = wind_bd[0];
        d.lat = wind_bd[1];
      }
    }
  }
  return data;
}

// 获取风向名称，参数为风向角
export const getWindDirection = dir => {
  var direction = '';
  for (var item of wind_directions) {
    if ((dir > 337.5 && dir <= 360) || (dir >= 0 && dir < 22.5)) {
      direction = '北风';
    }
    if (dir > item.range[0] && dir <= item.range[1]) {
      direction = item.name;
    }
  }
  return direction;
};

// 获取单位为米的风速，参数为km/h风速
export const getWindSpeedM = speed_k => {
  return Math.round(((speed_k * 1000) / 3600) * 100) / 100;
};



// WEBPACK FOOTER //
// ./src/components/AverageParticle/util.js